// extracted by mini-css-extract-plugin
module.exports = {"errorImage":"ErrorInformation_errorImage__2Mj7R","errorTitle":"ErrorInformation_errorTitle__3bLJh","errorInfo":"ErrorInformation_errorInfo__1H6Jy"};